import { render, staticRenderFns } from "./Votings.vue?vue&type=template&id=0071a4fa&scoped=true&"
import script from "./Votings.vue?vue&type=script&lang=ts&"
export * from "./Votings.vue?vue&type=script&lang=ts&"
import style0 from "./Votings.vue?vue&type=style&index=0&id=0071a4fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071a4fa",
  null
  
)

export default component.exports